module.exports = __webpack_public_path__ + "static/progressive-d3ef6db0094a7527e0102b9baabe161f.jpg";